import { Link } from "react-router-dom";
import PageMeta from "@/components/feature/PageMeta";
import SectionHeading from "@/components/feature/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/site";
import type { Faq } from "@/types/content";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedRisk from "./components/FeaturedRisk";
import LatestRecords from "./components/LatestRecords";
import SignalGuide from "./components/SignalGuide";
import GuidesPreview from "./components/GuidesPreview";
import CtaBanner from "./components/CtaBanner";

const SITE = "https://imgmmd.cn";

export default function Home() {
  const homeFaqs = (faqs as Faq[]).slice(0, 6);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "避雷哨",
      alternateName: "网站黑料风险记录库",
      url: `${SITE}/`,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE}/blacklist?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "避雷哨",
      url: `${SITE}/`,
      description:
        "避雷哨汇总网站黑料、避雷名单、不靠谱平台、诈骗举报与跑路记录，为消费者提供付款前的风险参考。",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: homeFaqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <>
      <PageMeta
        title="网站黑料_避雷名单_不靠谱平台与跑路记录查询 - 避雷哨"
        description="避雷哨汇总网站黑料、避雷名单、不靠谱平台、诈骗举报、跑路记录与投诉维权案例，帮助你在付款前快速识别风险网站，降低选错踩坑的概率。"
        keywords="网站黑料,避雷名单,不靠谱平台,诈骗举报,跑路记录,投诉汇总"
        path="/"
        jsonLd={jsonLd}
      />

      <Hero />
      <CategoryGrid />
      <FeaturedRisk />
      <LatestRecords />
      <SignalGuide />
      <GuidesPreview />

      <section className="border-y border-background-200 bg-background-100">
        <div className="mx-auto grid max-w-content grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
          <div>
            <SectionHeading
              eyebrow="常见问题"
              title="关于避雷哨，你可能想先了解的几件事"
              desc="信息从哪来、等级怎么分、发现错误怎么处理，都写在这里。"
            />
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
            >
              <i className="ri-information-line text-base" />
              了解内容原则
            </Link>
          </div>
          <FaqAccordion items={homeFaqs} />
        </div>
      </section>

      <div className="pt-16 md:pt-20">
        <CtaBanner />
      </div>
    </>
  );
}